export function renderGenGetByIdContentServerActionTemplate({
  join,
  joinText,
  ctxCacheReadImport,
  ctxCamelPlural,
  ctxSingular,
  populateImport,
  authorshipAliasBlock,
  ctxCacheLifeLine,
  ctxSelectClause,
  ctxTableVar,
  ctxSingleRowReturn,
  ctxSingularText
}: {
  join: string
  joinText: string
  ctxCacheReadImport: string
  ctxCamelPlural: string
  ctxSingular: string
  populateImport: string
  authorshipAliasBlock: string
  ctxCacheLifeLine: string
  ctxSelectClause: string
  ctxTableVar: string
  ctxSingleRowReturn: string
  ctxSingularText: string
}): string {
  return `'use server'

import db from '@admin/db'
import { ${join} } from '@admin/db/schema'
import { ${joinText} } from 'drizzle-orm'
import { alias } from 'drizzle-orm/pg-core'
${ctxCacheReadImport}
import { ${ctxCamelPlural}CacheTags } from './types'
import type { ${ctxSingular} } from './types'${populateImport}

${authorshipAliasBlock}

export async function get${ctxSingular}ById(id: string): Promise<${ctxSingular} | null> {
  'use cache'${ctxCacheLifeLine}
  cacheTag(${ctxCamelPlural}CacheTags.byId(id))
  cacheTag(${ctxCamelPlural}CacheTags.all)

  try {
    const result = await ${ctxSelectClause}.where(eq(${ctxTableVar}.id, id)).limit(1)
    if (result.length === 0) return null
    ${ctxSingleRowReturn}
  } catch (error) {
    console.error('Error fetching ${ctxSingularText}:', error)
    throw new Error('Failed to fetch ${ctxSingularText}')
  }
}
`
}
